import {RESIDENT_HOME_NO_TENANT_DATA_COPY} from "../lib/resident-home-owner-tenant-data";

export function ResidentHomeNoTenantData() {
  return <p className="text-muted-foreground text-sm">{RESIDENT_HOME_NO_TENANT_DATA_COPY}</p>;
}
